import { render } from "./AudienceSerieCreate.vue?vue&type=template&id=cdb51412&scoped=true"
import script from "./AudienceSerieCreate.vue?vue&type=script&lang=js"
export * from "./AudienceSerieCreate.vue?vue&type=script&lang=js"

import "./AudienceSerieCreate.vue?vue&type=style&index=0&id=cdb51412&lang=scss&scoped=true"
import "./AudienceSerieCreate.vue?vue&type=style&index=1&id=cdb51412&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb51412"]])

export default __exports__